module.exports = __webpack_public_path__ + "static/media/info.08b7765f.jpg";